<template>
  <div class="szw-row szw-w-full szw-border-bottom szw-justify-between szw-h-4">
    <span class="szw-w-5 szw-h-3 szw-text-center szw-rounded szw-bg-section-static szw-animate-pulse"></span>
    <span class="szw-w-17 szw-h-3 szw-text-center szw-rounded szw-bg-section-static szw-animate-pulse"></span>
    <span class="szw-w-5 szw-h-3 szw-text-center szw-rounded szw-bg-section-static szw-animate-pulse"></span>
  </div>
</template>
